import { CustomFonts } from 'app/components/custom-fonts';
import React, { Fragment } from 'react';
import { Spinner } from 'app/components/ui/spinner';
import { ErrorModal } from 'app/components/error-modal';
import { useTheme } from 'app/shared/contexts/theme';
import { useBuilding } from 'app/shared/contexts/building';
import { useErrors } from 'app/shared/contexts/errors';
import { ErrorPage } from 'app/pages/error';
import { useApi } from 'app/shared/contexts/api';
import { useAnalytics } from 'app/shared/hooks/use-analytics-hook';

interface AppContentWrapperProps {
  children: React.ReactNode;
}

export const AppContentWrapper = ({ children }: AppContentWrapperProps): JSX.Element => {
  const { theme } = useTheme();
  const { building } = useBuilding();
  const { genericErrors } = useErrors();
  const { apiUrl } = useApi();

  // Analytics + web-tracking init. Previously this hung off AppRoot, so it ran only on the redirect
  // hop — a direct link to a booking never initialised it at all.
  useAnalytics();

  if (genericErrors.length > 0 || !apiUrl) {
    return <ErrorPage />;
  }

  if (theme && building) {
    return (
      <Fragment>
        <CustomFonts />
        {/*
          * The scroll container (the body is locked in index.css); overscroll-y-contain keeps the bounce.
          *
          * `overflow-x-hidden` is load-bearing, not tidying: CSS computes a `visible` axis to `auto`
          * as soon as the other axis is not visible, so `overflow-y-auto` alone silently made this a
          * HORIZONTAL scroller too. On a trackpad that turned a sideways swipe into a sideways scroll
          * and a rubber-band, where every other miniapp simply does nothing.
          */}
        <div className="h-svh overflow-y-auto overflow-x-hidden overscroll-y-contain bg-background text-foreground">
          {children}
          <ErrorModal />
        </div>
      </Fragment>
    );
  }

  return (
    <div
      className="flex flex-col justify-center h-screen"
      data-testid="loading-container"
    >
      <Spinner />
    </div>
  );
};
